var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpVerifiedProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#up_verified_profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.103 13.356a10.092 10.092 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.441 1.441 0 01-.459.08h-.016a1.462 1.462 0 01-.476-.082 12.622 12.622 0 01-4.72-2.8 10.073 10.073 0 01-2.407-3.76A21.717 21.717 0 01.02 5.447v-.036c.009-.194.015-.4.018-.622a2.122 2.122 0 011.996-2.077 8.203 8.203 0 005.59-2.36l.008-.01a1.277 1.277 0 011.736 0l.015.011a8.205 8.205 0 005.59 2.36 2.114 2.114 0 011.996 2.077c0 .226.01.43.018.622v.015a21.753 21.753 0 01-.884 7.93z",
    fill: "#3177F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.103 13.356a10.091 10.091 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.44 1.44 0 01-.458.081V-.004c.315.004.618.126.85.34l.013.012a8.205 8.205 0 005.59 2.36 2.115 2.115 0 011.996 2.077c0 .226.01.429.018.622v.019a21.755 21.755 0 01-.882 7.93z",
    fill: "#0B42F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.282 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.073 1.706H8.5a5.777 5.777 0 01-4.088-1.697 5.798 5.798 0 010-8.191A5.777 5.777 0 018.5 4.207h.02c1.53.007 2.994.62 4.074 1.706A5.805 5.805 0 0114.282 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.281 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.072 1.706V4.209a5.78 5.78 0 014.072 1.705A5.805 5.805 0 0114.281 10z",
    fill: "#E0E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.478 8.989l-2.942 2.949-.636.637a.769.769 0 01-1.088 0l-1.368-1.37a.772.772 0 01.548-1.302.77.77 0 01.54.212l.824.825 3.035-3.041a.769.769 0 011.3.55.772.772 0 01-.212.54z",
    fill: "#2355FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "up_verified_profile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v20H0z"
  })))));
}

export default SvgUpVerifiedProfile;